export default function MementoPage() {
  return (
    <ul>
      <li>Memento: </li>
    </ul>
  );
}
